import { fetchApi } from '@/config/axiosSetting';
import {
  GetCulpritCustomerImagesTabsQueryParamsType,
  GetCulpritCustomerImagesTabsQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerImagesTabs/getCulpritCustomerImagesTabs.type';

export const getCulpritCustomerImagesTabsQueryFunction = (
  params: GetCulpritCustomerImagesTabsQueryParamsType,
): Promise<GetCulpritCustomerImagesTabsQueryResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/culprit/images/customer/entry_tabs/`,
  );
};
